export default __webpack_public_path__ + "static/media/Hauora-SemiBold.b8982950.woff2";